import { Box, BoxProps } from '@mui/material';
import { colorPalette } from '@qualifio/ui-commons';
import { forwardRef } from 'react';

export const Trait = forwardRef<HTMLDivElement, BoxProps>(function Trait(
  { children, sx = {}, ...props },
  ref,
) {
  return (
    <Box
      ref={ref}
      sx={{ borderBottom: `1px solid ${colorPalette.grey.main}`, p: 1, ...sx }}
      {...props}
    >
      {children}
    </Box>
  );
});
